import Vue from 'vue'
import App from './App.vue'
import router from './router'



import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import locale from 'element-ui/lib/locale/lang/tr-TR'
import VueResource from 'vue-resource';
import VueTheMask from 'vue-the-mask'

Vue.use(VueTheMask);
Vue.use(VueResource);


import './scss/index.scss'

Vue.use(ElementUI, {locale});


Vue.http.options.emulateJSON = true;
Vue.http.options.emulateHTTP = true;

Vue.http.options.root = 'https://api.denizhanguvenlik.com.tr/desafe';
if (process.env.NODE_ENV === 'development') {
    Vue.http.options.root = 'http://denizhan.crm/desafe';
}


import KVKKComponent from './components/KVKKContent';
import PrivatyComponent from './components/PrivatyContent';

Vue.component('kvkk-component', KVKKComponent);
Vue.component('privaty-component', PrivatyComponent);

Vue.config.productionTip = false;

new Vue({
    router,
    render: h => h(App)
}).$mount('#app')
